import { render, staticRenderFns } from "./NoMorePosts.vue?vue&type=template&id=1d6152e3&scoped=true"
import script from "./NoMorePosts.vue?vue&type=script&lang=js"
export * from "./NoMorePosts.vue?vue&type=script&lang=js"
import style0 from "./NoMorePosts.vue?vue&type=style&index=0&id=1d6152e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6152e3",
  null
  
)

export default component.exports